module.exports = __webpack_public_path__ + "assets/fonts/roboto-condensed-v13-latin-ext_latin_greek_cyrillic-700.woff2?74601e";


//////////////////
// WEBPACK FOOTER
// ../xod-client/src/core/assets/fonts/roboto-condensed-v13-latin-ext_latin_greek_cyrillic-700.woff2
// module id = 977
// module chunks = 0